import { getLoginTokenRequest } from '@/services/api/auth/AuthRequestService'
import store from '@/store/store'

/**
 * @description
 * Call request for get Login token and save it in Local Storage
 * 
 * @param {oject} params
 * @return {void}
 */
const getAndSaveLoginToken = () => {
    return new Promise((resolve, reject) => {
        let moduleToken = getModuleToken_FromParams()
        if (moduleToken !== undefined) {
            let params = { module_token: moduleToken }
            getLoginTokenRequest(params)
                .then(response => {
                    store.dispatch('AuthModule/loginActions', response ) // create local storage user data
                    resolve(response)
                })
                .catch((err) => {
                    console.log(err)
                    store.dispatch('AuthModule/logoutActions') // delete local storage user data
                    reject(err)
                })
        } // end if
        else
            reject( getErrorObject_IfTokenNotExistInURL() )
    })
} // end function

/**
 * @description
 * Get Object error when token not exist in URL
 * @return {Object}
 */
function getErrorObject_IfTokenNotExistInURL()
{
    return { 
        error: {
            response: {
                status: 500,
                message: 'token no existe en URL'
            }
        }
    }
}

/**
 * @description
 * Get module token from params
 * @return {void}
 */
const getModuleToken_FromParams = () => {
    try {
        return window.location.search.substr(1).split('=')[1];
    } catch (err) {
        return undefined
    }
    
} // end function


export {
    getAndSaveLoginToken,
    getModuleToken_FromParams,
}